import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import GraphNode from './GraphNode';
export var isGroupNode = Symbol('isGroupNode');
export var GroupNode =
/*#__PURE__*/
function (_GraphNode) {
  _inherits(GroupNode, _GraphNode);

  function GroupNode() {
    var _this;

    _classCallCheck(this, GroupNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GroupNode).call(this));
    _this[isGroupNode] = true;
    return _this;
  }

  _createClass(GroupNode, [{
    key: "applyProps",
    value: function applyProps(nextprops) {
      var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.applyMatrixProps(nextprops, prevProps);
    }
  }]);

  return GroupNode;
}(GraphNode);